import './style/App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from './componenets/Navbar';
import Home from './componenets/Home'
import SingleProduct from './componenets/SingleProduct';
import Bag from './componenets/Bag';
import Footer from './componenets/Footer';
import Buying from './componenets/Buying';
// <home/>

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='product/:id' element={<SingleProduct />} />
          <Route path='bag' element={<Bag />} />
          <Route path='/buying' element={<Buying />} />
        </Routes>
        <Footer />
      </BrowserRouter>

    </>
  );
}

export default App;
